import { useState } from "react";
// import FinancialModel from "../../stacks/financialModel/FinancialModelLocalStore";
import FinancialModelAWS from "../../stacks/financialModel/FinancialModelAWS";

export const useUpdateAllScenarios = (arr,cb) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState({});

  async function updateScenario(item) {
    const {forecastId,name,years} = item;
    const financialModelApi = FinancialModelAWS.getInstance();
    const fin = await financialModelApi.storeForecast(forecastId,{name,years,lastUpdated: new Date()});
    return fin;
  }

  async function refetch() {
    setLoading(true);
    try {
      for (let item of arr) {
        await updateScenario(item)
      }
      setData(arr);
      setError("");
      setLoading(false);
      cb && cb();
    } catch (err) {
      console.log(`ERROR adding forecasts ${err.message}`);
      setError(err.message);
      setLoading(false);
    }
  }

  return [{ loading, error, data }, refetch];
};